import React, { FC } from 'react'
import {
	Alert,
	ALERT_CODES_BG,
	ALERT_CODES_BP,
	ALERT_CODES_MSK,
	ALERT_CODES_SINGLE,
} from '../../../../../../../types/alert'
import SidebarBGAlert from './SidebarBGAlert'
import SidebarBPAlert from './SidebarBPAlert'
import SidebarInactiveAlert from './SidebarInactiveAlert'
import SidebarNewPatientAlert from './SidebarNewPatientAlert'
import SidebarMskRpeAlert from './SidebarMskRpeAlert'
import SidebarScreeningAlert from './SidebarScreeningAlert'
import SidebarMskPainAlert from './SidebarMskPainAlert'

interface SidebarAlertsReducerProps {
	readonly alert: Alert
}

const SidebarAlertsReducer: FC<SidebarAlertsReducerProps> = ({
	alert,
}: SidebarAlertsReducerProps) => {
	return (
		<>
			{Object.values(ALERT_CODES_BP).includes(
				(alert.data?.alert_code || '') as ALERT_CODES_BP
			) && <SidebarBPAlert alert={alert} />}

			{Object.values(ALERT_CODES_BG).includes(
				(alert.data?.alert_code?.replace(/^(\w+\.)/g, '') ||
					'') as ALERT_CODES_BG
			) && <SidebarBGAlert alert={alert} />}

			{alert.data?.alert_code === ALERT_CODES_SINGLE.INACTIVE && (
				<SidebarInactiveAlert alert={alert} />
			)}

			{alert.data?.alert_code === ALERT_CODES_SINGLE.NEW_PATIENT && (
				<SidebarNewPatientAlert alert={alert} />
			)}

			{alert.data?.alert_code === ALERT_CODES_MSK.MSK_RPE_DOWN && (
				<SidebarMskRpeAlert alert={alert} />
			)}

			{alert.data?.alert_code === ALERT_CODES_MSK.MSK_RPE_UP && (
				<SidebarMskRpeAlert alert={alert} />
			)}

			{alert.data?.alert_code === ALERT_CODES_MSK.MSK_PAIN_LEVEL && (
				<SidebarMskPainAlert alert={alert} />
			)}

			{alert.data?.alert_code ===
				ALERT_CODES_MSK.MSK_FEEDBACK_QUESTION && (
				<SidebarScreeningAlert alert={alert} />
			)}
		</>
	)
}

export default SidebarAlertsReducer
